import React, { useState, useEffect } from "react"
import Application from "services/applications/Application.service"
import ReviewOfficerExport from "./Review/License/ReviewOfficerExport"

let appService = null

appService = new Application(localStorage.getItem("authUser"))

const ReviewOfficer = props => {
  const [viewComponent, setviewComponent] = useState()

  useEffect(() => {
    fetchApplicationDetails(props.location.search.split("=")[1])
  }, [])

  const fetchApplicationDetails = appId => {
    appService.getApplicationDetails(appId).then(response => {
      // console.log(response)
      if (response.status) {
        // if (response.data.service.id == 1) {
        //   setviewComponent(<ReviewOfficerExport appDetails={response.data} />)
        // } else if (response.data.service.id == 2) {
        //   setviewComponent(<ReviewOfficerExport appDetails={response.data} />)
        // } else if (response.data.service.id == 3) {
        //   setviewComponent(<ReviewOfficerExport appDetails={response.data} />)
        // } else if (response.data.service.id == 4) {
        //   setviewComponent(<ReviewOfficerExport appDetails={response.data} />)
        // } else if (response.data.service.id == 6) {
        //   setviewComponent(<ReviewOfficerExport appDetails={response.data} />)
        // }
        setviewComponent(<ReviewOfficerExport appDetails={response.data} />)
      }
    })
  }

  return <>{viewComponent}</>
}

export default ReviewOfficer
